import Vue from 'vue';
import Component from 'vue-class-component';
import { MeetingsService } from '@/meetings/services/meetings.service';
import { MEETING_TYPES_VALUES, WAITING_ROOM_TEXT, _MEETINGS_STORE } from '@/meetings/values/meetings.values';
import { Student } from '@/meetings/models/student-front.model';
import { MEETINGS_VARIABLES } from '@/core/values/core.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { i18n } from '@/core/lang/core.i18n';
import { MAIN_MENU } from '@/core/values/core.values';
import KEYS from '@/values/keys';
import { CORE_ROUTES } from '@/core/core.router';

@Component({
  components: {}
})
export default class WaitingRoom extends Vue {

  public meetingId:number = 0;
  public classId:number = 0;
  public attendees:Array<Student> = [];
  public meetingReadyText:string = WAITING_ROOM_TEXT.NOT_READY;
  public host:any = { id:-1,text: ` ${i18n.t('meetings.waitingRoom.hostText')}`  };
  public className:string = 'Class';
  public roomName:string = 'Room';
  public loading:boolean = false;
  public checkMeetingInterval;
  public intervalTimeoutSeconds:number = 10;


  public createInterval(){
    this.checkMeetingInterval = window.setInterval(() => {
      this.checkMeeting();
    }, this.intervalTimeoutSeconds*1000);
  }

  public popupBlockedToast(){
    this.$EdToast.create({ 
      msg: `${this.$i18n.t('menu.popupBlocked')}`,
      type: TOAST_TYPES.WARNING,
      timeout: 10000,
      top: '0em'
    });
  }

  public async checkMeeting() {
    if(this.loading){
      return;
    }
    clearInterval(this.checkMeetingInterval);
    this.loading = true;
    MeetingsService.getSpecificMeetingService(this.meetingId, MEETING_TYPES_VALUES.TOHAINA).then((res:any) => {
      this.loading = false;
      const path = CORE_ROUTES.JOIN_MEETING.PATH
        .replace(':classId', this.classId.toString())
        .replace(':id', '-1')
        .replace(':meeting', this.meetingId.toString());
      window.location.href = path;
    }).catch(err => {
      if(err && err.status == 400 && err.data.message == MEETINGS_VARIABLES.MEETING_NOT_STARTED){
        this.$EdToast.create({ 
          msg: `${this.$i18n.t('meetings.waitingRoom.hostNotReady')}`,
          type: TOAST_TYPES.WARNING,
          timeout: 3500,
          top: '3em'
        });
      }
      else{
        this.showGenericModal(true,this.$i18n.t('meetings.waitingRoom.noLongerMember'));
      }
      this.createInterval();
      this.loading = false;
    });
  }
  
  public showGenericModal(changeRoute:boolean,body?,isError:boolean = true){
    var bodyStr = body ? body : i18n.t('meetings.customizeGroups.genericError');
    var portalNav = MAIN_MENU[0].pathName;
    this.$EdModal.createMessageModal({
      title: isError ? i18n.t('meetings.customizeGroups.errorTitle') : i18n.t('meetings.waitingRoom.successTitle'),
      body: bodyStr,
      type: isError ? KEYS.EVENT_TYPES.DANGER : KEYS.EVENT_TYPES.SUCCESS,
      action: () => {
        if(changeRoute) 
          window.location.href = portalNav;
        }
    });
  }

  beforeDestroy() {
    if(this.checkMeetingInterval) {
      clearInterval(this.checkMeetingInterval);
    }
  }

  mounted() {
    (this.$refs.EdLoading as any).show();
    let promiseAtendees = MeetingsService.getMeetingAtendees(this.meetingId);
    let promiseMeetingInfo = MeetingsService.getMeetingInfo(this.meetingId);

    Promise.all([promiseAtendees,promiseMeetingInfo]).then((values:Array<any>) => {      
      this.attendees = values[0].data;

      this.host.id = values[1].data.owner.id;
      this.className = values[1].data.eduacClass.name;
      this.roomName = values[1].data.name;

      if(!this.attendees.find(a => a.id == this.host.id)){
        this.attendees.unshift(new Student(values[1].data.owner));
      }

      (this.$refs.EdLoading as any).hide();
    });

    this.createInterval(); 
  }

  created() {
    this.meetingId = Number(this.$route.params.id);
    this.classId = Number(this.$route.params.classId);
    if(this.meetingId == -1 || this.classId == -1) {
      this.showGenericModal(true);
    }
  }

}